import React from "react";
import { Stack, Grid } from "@mantine/core";
import PageContent from "../shared/PageContent/PageContent";
import RepTypesCard from "./RepTypesCard";
import RecruitingSourcesCard from "./RecruitingSourcesCard";
import Permissions from "./Permissions";
import RepHealthSettingsCard from "./RepHealthSettingsCard";
import CompanyStructureCard from "./CompanyStructureCard";
function CompanyPage() {
  return (
    <>
      <PageContent title="Company Defaults">
        <Stack gap="lg">
          <Grid>
            <Grid.Col span={{ base: 12, lg: 6 }}>
              <RepTypesCard />
            </Grid.Col>
            <Grid.Col span={{ base: 12, lg: 6 }}>
              <RecruitingSourcesCard />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={12}>
              <CompanyStructureCard />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={12}>
              <Permissions />
            </Grid.Col>
          </Grid>
          <Grid>
            <Grid.Col span={12}>
              <RepHealthSettingsCard />
            </Grid.Col>
          </Grid>
        </Stack>
      </PageContent>
    </>
  );
}

export default CompanyPage;
